module.exports = __webpack_public_path__ + "static/media/Carter1.db5a9be8.m4v";